export default __webpack_public_path__ + "static/media/subscription-yellow.bcaf31c1.svg";